<app-main-nav-bar></app-main-nav-bar>
<!--1-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="location elem" style="display: block;">
          <div class="row">
            <div class="col col-12">
              <div class="head">
                <h2>اطلاعات اولیه</h2>
                <p>اطلاعات خود را وارد نمایید</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col col-12">
              <form [formGroup]="basicInformationForm">
                <app-select-field [Group]="basicInformationForm" [Icon]="true" [options]="states$"
                                  [fieldLabel]="'استان'"
                                  [fieldName]="'stateCode'" (OnChange)="onStateChange($event)"></app-select-field>
                <app-select-field [fieldLabel]="'شهر'" [Icon]="true" [options]="cities$" [Group]="basicInformationForm"
                                  [fieldName]="'cityCode'">
                </app-select-field>
                <br>
                <br>
                <app-custom-button
                  [disabled]="!basicInformationForm.valid"
                  [BackButton]="true"
                  [backUrl]="'/health/family'"
                  (OnClick)="goNext()"
                  [LabelText]="'ادامه'"
                  [Show]="true">
                </app-custom-button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
